import { setReviewField } from 'feature/claims/claimSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import {
	Checkbox,
	FormControl,
	MarkdownRenderer,
	Stack,
	Typography,
} from 'styles';
import { REVIEW_FIELDS } from 'types/Claim';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const AknowledgeData = () => {
	const dispatch = useDispatch<AppDispatch>();
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});

	const { claimData } = useSelector((store: RootState) => store.claim);

	const handleChange = (value: boolean) => {
		dispatch(
			setReviewField({ name: REVIEW_FIELDS.REVIEW_CONSENT, value: value }),
		);
	};

	return (
		<Stack gap={'20px'}>
			<Typography variant="caption" sx={{ whiteSpace: 'pre-line' }}>
				<MarkdownRenderer>
					{tClientLabels('claim.review.aknowledge')}
				</MarkdownRenderer>
			</Typography>

			<FormControl
				sx={{
					maxWidth: 'fit-content',
				}}
			>
				<Checkbox
					sx={{
						pl: 0,
					}}
					label={tClientLabels('claim.review.aknowledgeCheckbox')}
					onChange={e => handleChange(e.target.checked)}
					checked={claimData.receipt[REVIEW_FIELDS.REVIEW_CONSENT]}
				/>
			</FormControl>
		</Stack>
	);
};

export default AknowledgeData;
